export { default as SvgEmail } from './email'
export { default as SvgPhone } from './phone'
